import { render } from "./premium.vue?vue&type=template&id=fefa8f34&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"

import "./premium.vue?vue&type=style&index=0&id=fefa8f34&scoped=true&lang=css"
import "./premium.vue?vue&type=style&index=1&id=fefa8f34&lang=css"
script.render = render
script.__scopeId = "data-v-fefa8f34"

export default script